import { render } from "./ManagerLanding.html?vue&type=template&id=5f3c36d2&external"
import script from "./ManagerLanding.vue?vue&type=script&lang=js"
export * from "./ManagerLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__